module.exports = __webpack_public_path__ + "img/action-RN.82c500a6.svg";